
// import React, { createContext, useState, useEffect } from 'react';

// export const UserContext = createContext({});

// const UserContextProvider = ({ children }) => {
//   // Initialize state from localStorage if available
//   const [isAdmin, setIsAdmin] = useState(() => {
//     const saved = localStorage.getItem('isAdmin');
//     return saved ? JSON.parse(saved) : false;
//   });
  
//   const [isTeacher, setIsTeacher] = useState(() => {
//     const saved = localStorage.getItem('isTeacher');
//     return saved ? JSON.parse(saved) : false;
//   });
  
//   const [isStudent, setIsStudent] = useState(() => {
//     const saved = localStorage.getItem('isStudent');
//     return saved ? JSON.parse(saved) : false;
//   });
  
//   const [isGuest, setIsGuest] = useState(() => {
//     const saved = localStorage.getItem('isGuest');
//     return saved ? JSON.parse(saved) : true;
//   });
  
//   const [userInfo, setUserInfo] = useState(() => {
//     const saved = localStorage.getItem('userInfo');
//     return saved ? JSON.parse(saved) : {};
//   });

//   // Save to localStorage whenever state changes
//   useEffect(() => {
//     localStorage.setItem('isAdmin', JSON.stringify(isAdmin));
//   }, [isAdmin]);

//   useEffect(() => {
//     localStorage.setItem('isTeacher', JSON.stringify(isTeacher));
//   }, [isTeacher]);

//   useEffect(() => {
//     localStorage.setItem('isStudent', JSON.stringify(isStudent));
//   }, [isStudent]);

//   useEffect(() => {
//     localStorage.setItem('isGuest', JSON.stringify(isGuest));
//   }, [isGuest]);

//   useEffect(() => {
//     localStorage.setItem('userInfo', JSON.stringify(userInfo));
//   }, [userInfo]);

//   // Load user info from localStorage on app start
//   useEffect(() => {
//     const savedUserInfo = localStorage.getItem('userInfo');
//     const savedUserRole = localStorage.getItem('userRole');

//     if (savedUserInfo && savedUserRole) {
//       try {
//         const parsedUserInfo = JSON.parse(savedUserInfo);
//         setUserInfo(parsedUserInfo);
//         setUserRole(savedUserRole);
//         console.log('🔄 Restored user session:', parsedUserInfo);
//       } catch (error) {
//         console.error('Error parsing saved user info:', error);
//         // Clear corrupted data
//         localStorage.removeItem('userInfo');
//         localStorage.removeItem('userRole');
//       }
//     }
//   }, []);

//   const setUserRole = (userRole) => {
//     setIsAdmin(userRole === 'Admin');
//     setIsTeacher(userRole === 'Teacher');
//     setIsStudent(userRole === 'Student');
//     setIsGuest(userRole === 'guest');

//     // Save to localStorage
//     localStorage.setItem('userRole', userRole);
//   };

//   // Enhanced setUserInfo that also saves to localStorage
//   const setUserInfoWithPersistence = (newUserInfo) => {
//     setUserInfo(newUserInfo);

//     if (newUserInfo && Object.keys(newUserInfo).length > 0) {
//       // Save to localStorage
//       localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
//       console.log('💾 Saved user info to localStorage:', newUserInfo);
//     } else {
//       // Clear localStorage if userInfo is empty
//       localStorage.removeItem('userInfo');
//       localStorage.removeItem('userRole');
//       console.log('🧹 Cleared user info from localStorage');
//     }
//   };

//   // Function to get current user ID
//   const getCurrentUserId = () => {
//     return userInfo?.User_id || localStorage.getItem('User_id') || null;
//   };

//   // Function to clear all user data (for logout)
//   const clearUserData = () => {
//     setUserInfo({});
//     setUserRole('guest');
//     localStorage.removeItem('userInfo');
//     localStorage.removeItem('userRole');
//     localStorage.removeItem('User_id');
//     console.log('🧹 Cleared all user data');
//   };

//   const value = {
//     isAdmin,
//     isTeacher,
//     isStudent,
//     isGuest,
//     userInfo,
//     setUserRole,
//     setUserInfo: setUserInfoWithPersistence,
//     getCurrentUserId,
//     clearUserData,
//   };

//   return (
//     <UserContext.Provider value={value}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export default UserContextProvider;












//  // setIsGuest(false);
//     // if (userRole === 'admin') {
//     //   setIsAdmin(true);
//     //   setIsTeacher(false);
//     //   setIsStudent(false);
//     //   setIsGuest(false);
//     // } else if (userRole === 'teacher') {
//     //   setIsAdmin(false);
//     //   setIsTeacher(true);
//     //   setIsStudent(false);
//     //   setIsGuest(false);
//     // } else if (userRole === 'student') {
//     //   setIsAdmin(false);
//     //   setIsTeacher(false);
//     //   setIsStudent(true);
//     //   setIsGuest(false);
//     // }
//     // else if (userRole === 'guest') {
//     //   setIsAdmin(false);
//     //   setIsTeacher(false);
//     //   setIsStudent(true);
//     //   setIsGuest(false);
//     // }

import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext({});

const UserContextProvider = ({ children }) => {
  // Initialize state from localStorage if available
  const [isAdmin, setIsAdmin] = useState(() => {
    const saved = localStorage.getItem('isAdmin');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [isTeacher, setIsTeacher] = useState(() => {
    const saved = localStorage.getItem('isTeacher');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [isStudent, setIsStudent] = useState(() => {
    const saved = localStorage.getItem('isStudent');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [isGuest, setIsGuest] = useState(() => {
    const saved = localStorage.getItem('isGuest');
    return saved ? JSON.parse(saved) : true;
  });
  
  const [userInfo, setUserInfo] = useState(() => {
    const saved = localStorage.getItem('userInfo');
    return saved ? JSON.parse(saved) : {};
  });

  // Save to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('isAdmin', JSON.stringify(isAdmin));
  }, [isAdmin]);

  useEffect(() => {
    localStorage.setItem('isTeacher', JSON.stringify(isTeacher));
  }, [isTeacher]);

  useEffect(() => {
    localStorage.setItem('isStudent', JSON.stringify(isStudent));
  }, [isStudent]);

  useEffect(() => {
    localStorage.setItem('isGuest', JSON.stringify(isGuest));
  }, [isGuest]);

  useEffect(() => {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }, [userInfo]);

  const setUserRole = (userRole) => {
    setIsAdmin(userRole === 'Admin');
    setIsTeacher(userRole === 'Teacher');
    setIsStudent(userRole === 'Student');
    setIsGuest(userRole === 'guest');
  };

  // Centralized logout function
  const logout = async () => {
    try {
      console.log("🔄 Centralized logout started...");
      
      // Call logout API
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
        credentials: "include",
        method: "POST",
      });
      
      // Clear all state
      setUserInfo({});
      setUserRole('guest');
      
      // Clear all localStorage
      localStorage.removeItem("User_id");
      localStorage.removeItem("username");
      localStorage.removeItem("usertype");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userRole");
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("isTeacher");
      localStorage.removeItem("isStudent");
      localStorage.removeItem("isGuest");
      
      console.log("✅ Centralized logout completed");
      
      // Redirect to home
      window.location.href = '/';
      
    } catch (error) {
      console.error("❌ Logout error:", error);
      // Even if API fails, clear everything
      setUserInfo({});
      setUserRole('guest');
      localStorage.clear();
      window.location.href = '/';
    }
  };

  const value = {
    isAdmin,
    isTeacher,
    isStudent,
    isGuest,
    userInfo,
    setUserRole,
    setUserInfo,
    logout, // Add logout function to context
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;












 // setIsGuest(false);
    // if (userRole === 'admin') {
    //   setIsAdmin(true);
    //   setIsTeacher(false);
    //   setIsStudent(false);
    //   setIsGuest(false);
    // } else if (userRole === 'teacher') {
    //   setIsAdmin(false);
    //   setIsTeacher(true);
    //   setIsStudent(false);
    //   setIsGuest(false);
    // } else if (userRole === 'student') {
    //   setIsAdmin(false);
    //   setIsTeacher(false);
    //   setIsStudent(true);
    //   setIsGuest(false);
    // }
    // else if (userRole === 'guest') {
    //   setIsAdmin(false);
    //   setIsTeacher(false);
    //   setIsStudent(true);
    //   setIsGuest(false);
    // }